import { getCode, initFirebase } from "../domain/domain";
import Vue from "vue";
import { getUrlParameter } from "../domain/utils";

export function accessSession() {  
    initFirebase();
  
    function invalidCode() {
      alert("Invalid code");
    }
  
    let app = new Vue({
      el: "#app",
      data: {
        accessCode: "",
      },
      methods: {
        doAccess: function () {
          getCode(app.accessCode).then((code_entry) => {
            if (!code_entry) {
              invalidCode();
            } else {
              let size = getUrlParameter("size");
              let size_param = size ? "&size=" + size : "";
              window.location.href =
                "draw.html?code=" + app.accessCode + "&session=" + code_entry.session_key + size_param;
            }
          });
        },
      },
    });
  }